export default __webpack_public_path__ + "static/media/processor-icon.53ff0c0c.svg";